import { getTimezoneName } from '@calendly/timezone-tools'
import { DetailsItem as Item } from '@calendly/booking-kit'
import { TimezoneIcon } from '@calendly/ui/components/icons'

export default ({ value, bookingAppRedesign = false }) => (
  <Item>
    <TimezoneIcon data-id="details-item-icon" spacingRight={8} size={bookingAppRedesign ? 'standard' : 'large'} />
    {getTimezoneName(value)}
  </Item>
)
